import { useIsMounted } from '@sats-group/ui-lib/react/hooks/use-is-mounted';
import Tag from '@sats-group/ui-lib/react/tag/tag';
import cn from 'classnames';
import React from 'react';
import ClubLoadIndicator from '../club-load-indicator/club-load-indicator';
import OpenStatus from '../open-status/open-status';
import {
  backgrounds,
  type LoadAndOpenStatus as Props,
} from './load-and-open-status.types';

const LoadAndOpenStatus: React.FunctionComponent<Props> & {
  backgrounds: typeof backgrounds;
} = ({
  background = backgrounds.light,
  loadFactor,
  loadIndicator,
  openStatus,
}) => {
  const isMounted = useIsMounted();
  const isOpen = openStatus?.isOpen;

  return isMounted ? (
    <div className="load-and-open-status">
      {isOpen && loadFactor ? (
        <div
          className={cn('load-and-open-status__item', {
            'load-and-open-status__item--fixed-background':
              background === backgrounds.fixed,
          })}
        >
          <ClubLoadIndicator
            loadFactor={loadFactor}
            tagTheme={Tag.themes.fixed}
            {...loadIndicator}
          />
        </div>
      ) : null}
      {openStatus ? (
        <div
          className={cn('load-and-open-status__item', {
            'load-and-open-status__item--fixed-background':
              background === backgrounds.fixed,
          })}
        >
          <OpenStatus shouldShowStatus={!openStatus.isOpen} {...openStatus} />
        </div>
      ) : null}
    </div>
  ) : null;
};

LoadAndOpenStatus.backgrounds = backgrounds;

export default LoadAndOpenStatus;
